module.exports = __webpack_public_path__ + "static/media/6.c41c52e7.mp4";